import Layout from "../layout";
import FormSurat from "./_components/FormSurat";

export default function Home() {
    return (
        <Layout>
            <div className="min-h-[calc(100vh-64px)] bg-gray-50 flex items-center justify-center p-4">
                <div className="w-full max-w-4xl">
                    <FormSurat />
                </div>
            </div>
        </Layout>
    );
}